module.exports = __webpack_public_path__ + "static/media/Ensemble.6c1e422b.svg";